<template>
  <div class="w-full h-full">
    <div
      class="w-full h-full model-view"
      v-loading="loadingEngine"
      element-loading-background="#0a232c"
    >
      <video id="playerEngineId" autoplay playsinline muted class="engineVideo w-full"></video>
    </div>
    <div class="absolute top-0 left-0 w-full h-full bg-[#0a232c]" v-if="showLoadProgress"></div>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>

<script>
import PlayerProgress from './playerProgress'

export default {
  name: 'ModelPreview',
  components: { PlayerProgress },
  props: {
    cloudRender: {
      type: Object,
      default: () => {},
    },
    modelInfo: {
      type: Object,
      defalut: () => {
        return {
          type: '',
          textureInfoId: '',
          modelInfoId: '', // 模型文件id，云渲染路径又是模型加载名称
        }
      },
    },
  },
  data() {
    return {
      player: null, // player实例
      loadingEngine: false, // 引擎加载状态
      showLoadProgress: true, // 进度条显隐
      loadType: '', // 进度条类型
      sceneRootNode: 0, // 根节点
      loadPercentage: 0, // 进度条值
      modelEngineId: '',
      loadTaskId: '',
    }
  },
  created() {
    this.loadingEngine = true
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
    // 云渲染协议
    cloudProtocol() {
      return this.modelSetting.cloudProtocol || 'ws'
    },
    // 云渲染服务路径
    cloudServerPath() {
      return this.modelSetting.cloudServerPathVulkan || 'renderapi.wiz.top:7082'
    },
  },
  async mounted() {
    this.runPlayer()
  },
  async beforeDestroy() {
    if (this.player) {
      this.cloudRender.Engine.destroyEngine()
      // this.player.Native.OperatingMode.EventPickUpNode.disconnect(this.pickupWatch)
      // this.player.Native.Node.EventSelectNode.disconnect(this.selectWatch)
    }
  },
  methods: {

    // 加载player引擎 sdk
    async runPlayer(engineId) {
      this.modelEngineId = 'sourceView'
      const param = {
        signalServer: `${this.cloudProtocol}://${this.cloudServerPath}`,
        options: {
          videoDom: document.getElementById('playerEngineId'),
          DomType: this.modelSetting.cloudRenderLoadMode === 'img' ? 1 : 0,
          userTimeout: 1000 * 60 * 60, // 用户操作超时设置，毫秒
          engineId: engineId || this.modelEngineId, // 引擎会话id，如果已存在则连接，没有则创建，会话在断开连接后超时自动关闭
          exitTimeout: 1000 * 60, // 用户超时后多久断开会话
          maxTimeout: 1000, // 会话超时时间，允许掉线后引擎保存多久，在该时间内可重新连接到会话，否则会创建新的会话
          // openDebug: true,
        },
      }
      const res = await this.cloudRender.Engine.loadEngine(param)
      const data = res.data
      this.player = data.getDataInfo()

      // window.player = this.player
      // window.cloudRender = this.cloudRender
      // cloudRender.Setting.set({
      //   name: 'display.autoUpdateFrame',
      //   type: 'bool',
      //   value: true,
      // })
      this.loadingEngine = false
      // 实例化完成将实例化后的player传出去
      this.$emit('sendPlayer', this.player)
      this.initPlayer(engineId)
    },
    // 初始化player
    async initPlayer() {
      const settingsFileUrl = `data://../apps/${this.modelSetting.folderName}/settings.json`
      const res = await this.cloudRender.Setting.getSettingData(settingsFileUrl)
      const settingsData = res.data
      if (settingsData) {
        const defaultSettings = JSON.parse(settingsData)
        await this.cloudRender.Setting.set(defaultSettings.Show)
      }

      // this.player.Native.Tools.EventBrowseLClick.connect((data) => {
      //   this.$emit('leftClick', data)
      // })
      // 加载全局地图
      // await this.cloudRender.GIS.loadGis(this.modelSetting.globalMapPath)
      await this.loadModelSdk()
      // this.cloudRender.Setting.set({
      //   name: 'func.nodetips.enable',
      //   value: false,
      // })
      // 点选监听
      // this.player.Native.OperatingMode.EventPickUpNode.connect(this.pickupWatch)
      // this.player.Native.Node.EventSelectNode.connect(this.selectWatch)
    },
    // 加载模型
    async loadModelSdk() {
      this.cloudRender.Dispatch.on('loadNode', this.loadModelConnect)
      const url = `data://../apps/${this.modelSetting.folderName}/models/${this.modelInfo.modelInfoId}/${this.modelInfo.modelInfoId}.${this.modelInfo.type}`
      const query = {
        targetUrl: url,
        fileUrl: `${
          Wiz.GetApiClientInstance('file-management')?.basePath
        }/api/file-management/files/${this.modelInfo.modelInfoId}/download`,
        tempPath: url,
        options: {
          nodeId: 'model',
          httpOptions: {
            methods: 'GET',
            header: {
              Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
            },
          },
        },
      }
      if (this.modelInfo.textureInfoId) {
        const urlM = `data://../apps/${this.modelSetting.folderName}/models/${this.modelInfo.modelInfoId}/${this.modelInfo.textureInfoId}.zip`
        const nodeDecals = {
          targetUrl: urlM,
          fileUrl: `${
            Wiz.GetApiClientInstance('file-management')?.basePath
          }/api/file-management/files/${this.modelInfo.textureInfoId}/download`,
          tempPath: urlM,
        }
        query.options.nodeDecals = nodeDecals
      }
      const res = this.cloudRender.Node.addNode(query)
    },
    // 加载、下载进度
    loadModelConnect: _.throttle(async function loadMsg(res) {
      if (res.data.type === 'nodeDecals') {
        switch (res.data.currentState) {
          case 1:
            this.showLoadProgress = true
            this.loadType = '贴图加载中...'
            this.loadPercentage = _.round(res.data.process, 2)
            break
          case 3:
            this.showLoadProgress = true
            this.loadType = '贴图下载中...'
            this.loadPercentage = _.round(res.data.process, 2)
            break
          case 4:
            this.showLoadProgress = false
            this.loadType = ''
            this.loadPercentage = 0
            break
          case 5:
            this.showLoadProgress = false
            this.loadType = ''
            this.loadPercentage = 0
            break
          default:
            break
        }
      } else if (res.data.type === 'nodeStatus') {
        switch (res.data.currentState) {
          case 1:
            this.showLoadProgress = true
            this.loadType = '模型加载中...'
            this.loadPercentage = _.round(res.data.process, 2)
            break
          case 3:
            this.showLoadProgress = true
            this.loadType = '模型下载中...'
            this.loadPercentage = _.round(res.data.process, 2)
            break
          case 4:
            this.showLoadProgress = false
            this.loadType = ''
            this.loadPercentage = 0
            this.cloudRender.Dispatch.off('loadNode', this.loadModelConnect)
            const rootNode = await this.player.Native.Node.getRoot()
            this.player.Native.Camera.moveToNode(rootNode, 2)
            this.$emit('loadModelEnd')
            break
          case 5:
            this.showLoadProgress = false
            this.loadType = ''
            this.loadPercentage = 0
            break
          default:
            break
        }
      } else if (!res.status) {
        this.$message.warning(res.message)
        this.showLoadProgress = false
        this.loadType = ''
        this.loadPercentage = 0
      }
    }, 100),
    // 点选选中监听
    // async pickupWatch(data) {
    //   console.log('点选选中监听', data)
    // },
    // // 接口选中监听
    // async selectWatch(node, status) {
    //   console.log('接口选中监听', node, status)
    // },
  },
}
</script>

<style lang='scss' scoped>
.engineVideo {
  height: 100%;
  object-fit: fill;
}
.model-view {
  transform: scale(1, 1);
  transform-origin: 'top left';
}
</style>
